module.exports = __webpack_public_path__ + "img/11-03.7e5aa51e.png";